// 列表标签显示
import {defineStore} from 'pinia'
import router from "@/router";
import {toRaw} from "vue";

let dynamicRoutes = [];
export const loginUserStore = defineStore({
    persist: {
        enabled: true, // 是否启用持久化
        strategies: [
            {
                key:"loginUserStore",//自定义存储名称
                storage: localStorage, // 存储介质，可以是 localStorage、localStorage 等
            },
        ],
    },
    // 唯一的名称，如 id
    id: 'loginUserStore',
    // 状态定义 (数据源)
    state: () => ({
        auth_token: String,
        refresh_token: String,
        sessionInfo:JSON,
        dynamicRoutes:[]
    }),
    // 可选的 actions
    actions: {
        setLoginUser(data) {
            this.auth_token=data.auth_token;
            this.refresh_token=data.refresh_token;
            this.sessionInfo = data.sessionInfo;
            const sessionInfo = toRaw(this.sessionInfo);
            // 清空动态路由
            dynamicRoutes = [];
            // 重新更新动态路由
            this.getDynamicRoutesFun(sessionInfo.userPermissions);
            // 重置vue-route
            dynamicRoutes.forEach(route => {
                router.addRoute(route)
            })
            // 用于在路由处使用
            this.dynamicRoutes = dynamicRoutes;
        },
        // 递归查询
        getDynamicRoutesFun(permissionData){
            for (let i = 0; i < permissionData.length; i++) {
                if(permissionData[i].permissionType == 1 // 必须是菜单
                    && permissionData[i].permission!=null // 必须有地址
                    && permissionData[i].permission!="" ){
                    //console.info(permissionData[i].permission)
                    const permission = {
                        path: permissionData[i].permission,
                        component:  () => import('@/views'+permissionData[i].permission+'.vue'),
                        meta:{
                            permissionId: permissionData[i].permissionId,
                            permission:permissionData[i].permission,
                            permissionName: permissionData[i].permissionName,
                            icon: permissionData[i].icon,
                            permissionParent: permissionData[i].permissionParent,
                            permissionType: permissionData[i].permissionType,
                        }
                    }
                    // 动态添加路由
                    dynamicRoutes.push(permission)
                    if(permissionData[i].userPermissionChildren!=null){
                        this.getDynamicRoutesFun(permissionData[i].userPermissionChildren)
                    }
                }
            }
        },
        getMenu:function(){
            const sessionInfo = toRaw(this.sessionInfo);
            return sessionInfo.userPermissions;
        },
        checkHasPermission:function(permission){
            const sessionInfo = toRaw(this.sessionInfo);
            return JSON.stringify(sessionInfo).indexOf(permission)>-1;
        },
        getMetaFromDynamicRoutesById(id){
            let MyDynamicRoutes = this.dynamicRoutes ;
            for (let i = 0; i < MyDynamicRoutes.length; i++) {
                var meta = toRaw(MyDynamicRoutes[i].meta);
                if(meta.permissionId == id){
                    return meta;
                }
            }
        }
    }
})